import LazyLoad from 'vanilla-lazyload';

class LazyLoader {
  private get options() {
    return {
      elements_selector: '.js-lazy',
      data_src: 'lazy-src',
      data_bg: 'lazy-bg',
      class_loading: 'lazyload--loading',
      class_loaded: 'lazyload--loaded',
      class_error: 'lazyload--error',
      callback_enter: this.setErrorOnEmpty,
    };
  }
  constructor() {
    this.init();
  }

  public lazyLoad = LazyLoad;

  private setErrorOnEmpty = (element: HTMLElement) => {
    if (element.tagName === 'IMG') return;
    const value = element.getAttribute(`data-${this.options.data_bg}`);
    if (!value) {
      element.classList.add(this.options.class_error!);
    }
  }

  public init() {
    this.lazyLoad = new LazyLoad(this.options);
  }
}

export { LazyLoader };
